import toast from "react-hot-toast";
import i18next from "i18next";
import {BaseClient} from "../../Api/HttpClient";

export const createBranchSlice = (set, get) => ({
    branches: [],
    branchesNotPaginated: [],
    branchMetaData: {},
    branchDetail: {},

    getMyBranches: async (page = null, search = null) => {
        let params = {}
        if(page){
            params = {page: page};
        }
        if(search) {
            params = {...params, search: search}
        }

        await BaseClient().get(`/branches?${new URLSearchParams(params).toString()}`)
            .then(response => {
                if (response.status === 200) {
                    set({branches: response.data.data})
                    set({branchMetaData: response.data.meta})
                } else {
                    toast.error(response.data);
                }
            })
    },
    createBranch: async (data) => {
        return await BaseClient().post('/branches', data)
            .then(response => {
                if (response.status === 200 || response.status === 201) {
                    set((state) => ({
                        branches: [...state.branches, response.data],
                    }));

                    return response.data
                } else {
                    console.log(response)
                }
            }).catch(error => {
                console.log(error)
            })
    },
    updateBranch: async (id, data) => {
        await BaseClient().patch(`/branches/${id}`, data)
            .then(response => {
                if (response.status === 200) {
                    set((state) => ({
                        branches: state.branches.map((branch) =>
                            branch.id === id ? { ...branch, ...data } : branch
                        ),
                    }));

                    return response.data
                } else {
                    toast.error(response.data);
                }
            })
    },
    deleteBranch: async (id) => {
        await BaseClient().delete(`/branches/${id}`)
            .then(response => {
                if (response.status === 200) {
                    set((state) => ({
                        branches: state.branches.filter((branch) => branch.id !== id),
                    }));

                    return response.data
                } else {
                    toast.error(response.data);
                }
            })
    },
    getMyBranchesNotPaginated: async () => {
        await BaseClient().get(`/branches-not-paginated`)
            .then(response => {
                if (response.status === 200) {
                    set({branchesNotPaginated: response.data})
                } else {
                    toast.error(response.data);
                }
            })
    },

    getBranchesForUser: async (userId, page = 1, search = null) => {
        try {
            let params = { page };
            if (search) {
                params.search = search;
            }
            const response = await BaseClient().get(`/users/${userId}/branches?${new URLSearchParams(params).toString()}`);
            if (response.status === 200) {
                return {
                    data: response.data?.data || [],
                    meta: response.data?.meta || {}
                };
            } else {
                toast.error(response.data);
                return { data: [], meta: {} };
            }
        } catch (error) {
            console.error('Error fetching branches for user:', error);
            toast.error(i18next.t('branches.toast_fetch_error'));
            return { data: [], meta: {} };
        }
    },

    getBranchDetail: async (branchId) => {
        try {
            const response = await BaseClient().get(`/branches/${branchId}`);
            if (response.status === 200) {
                set({ branchDetail: response.data });
                return response.data;
            } else {
                toast.error(response.data);
                return null;
            }
        } catch (error) {
            console.error('Error fetching branch detail:', error);
            toast.error(i18next.t('branches.toast_fetch_detail_error'));
            return null;
        }
    }
})